exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".c-bb-button {\n  border: 0;\n  border-radius: 0;\n  color: #fff;\n  cursor: pointer;\n  font-size: 16px; }\n  .c-bb-button--circle {\n    align-items: center;\n    background: #333;\n    border-radius: 50%;\n    color: #fff;\n    display: inline-flex;\n    font-size: 12px;\n    height: 28px;\n    justify-content: center;\n    text-transform: uppercase;\n    width: 28px; }\n    .c-bb-button--circle i {\n      font-size: 17px; }\n    .c-bb-button--circle:hover {\n      background: #000;\n      color: #fff; }\n  .c-bb-button--inactive {\n    background: #d8d8d8;\n    color: black; }\n  .c-bb-button .icon {\n    margin-right: 10px; }\n  .c-bb-button--primary {\n    background: #000; }\n  .c-bb-button--secondary {\n    background: #ececec;\n    color: #000; }\n\nbutton[disabled] {\n  opacity: 0.7; }\n\n.c-bb-languages .c-bb-button {\n  cursor: default; }\n  .c-bb-languages .c-bb-button--inactive {\n    cursor: pointer; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/@browsbox-ui/bb-button/button.scss
// module id = 1915
// module chunks = 0